<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('smsBrandName') }}</h3>
      <div class="tile-body">
        <div class="c-config-content">
          <div v-if="firstLoading">
            <skeleton-loading>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
              </row>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
              </row>
            </skeleton-loading>
          </div>
          <div v-else>
            <div class="c-template-table table-responsive c-role-table">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{ $t('smsBrandNameInfo') }}</th>
                  <th>{{ $t('status') }}</th>
                  <th>{{ $t('smsTemplateList') }}</th>
                </tr>
                </thead>
                <tbody v-if="listLoading" class="text-center text-primary">
                <tr>
                  <th colspan="3">
                    <b-spinner></b-spinner>
                  </th>
                </tr>
                </tbody>
                <tbody v-else-if="!itemCount" class="text-center text-gray-999">
                <tr>
                  <th colspan="3">
                    {{ $t('noSMSBrandNameFound') }}
                  </th>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <p>
                      <span>{{$t('name')}}: </span><b>{{ item.name }}</b>
                    </p>
                    <p v-if="item.approveTime && item.ads">
                      <span>{{ $t('ads') }}: </span>
                      <b>{{ item.privateFee ? item.adsFee : item.gateway.adsFee | numFormat }}</b>
                      <b>{{ $store.state.user.client.country.currency }}/sms </b>
                    </p>
                    <p v-if="item.approveTime && item.care">
                      <span>{{ $t('care') }}: </span>
                      <b>{{ item.privateFee ? item.careFee : item.gateway.careFee | numFormat }}</b>
                      <b>{{ $store.state.user.client.country.currency }}/sms </b>
                    </p>
                    <p v-if="item.approveTime">
                      <span>{{ $t('monthlyFee') }}: </span>
                      <b>{{ item.privateFee ? item.monthlyFee : item.gateway.monthlyFee| numFormat }} </b>
                      <b>{{ $store.state.user.client.country.currency }}/{{ $t('month') }}</b>
                    </p>
                  </td>
                  <td>
                    <span v-if="item.approveTime" class="badge badge-success">{{$t('approved')}}</span>
                    <span v-else class="badge badge-danger">{{$t('denied')}}</span>
                  </td>
                  <td>
                    <s-m-s-template :brand-name="item"></s-m-s-template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '../../../../mixins/List';
import SMSTemplate from "@/views/setting/communication/sms/SMSTemplate";

export default {
  components: {SMSTemplate},
  mixins: [list],
  data: function () {
    return {
      service: '/sms-brand-name'
    }
  },
  methods: {
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('idCopied'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    getStatus(item) {
      if (!item.submitTime) {
        return this.$t('draft')
      } else if (item.approveTime) {
        return this.$t('approved')
      } else if (item.denyTime) {
        return this.$t('denied');
      } else {
        return this.$t('waiting');
      }
    },
  },
}
</script>